import type { IntentDefinition } from '../types/LocalAiTypes';

export function contextMatches(intent: IntentDefinition, route: string): boolean {
  if (intent.allowedContexts.length === 0) return true;
  return intent.allowedContexts.some((context) => {
    if (context === 'table') return document.querySelector('table, [role="grid"]') !== null;
    return route.startsWith(context);
  });
}

export function contextBoost(intent: IntentDefinition, route: string): number {
  if (intent.allowedContexts.length === 0) return 0;
  return contextMatches(intent, route) ? 0.04 : -0.18;
}
